import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { File as FileModel } from 'src/app/classes/models';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-logo-file-upload',
  templateUrl: './logo-file-upload-modal.component.html',
  styleUrls: ['./logo-file-upload-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LogoFileUploadModalComponent {
  Files: FileModel[] = [];
  File: File | null = null;
  logo?: string;

  constructor(
    private UtilityService: UtilityService,
    private activeModal: NgbActiveModal,
    private ToastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  continue() {
    if (!this.File) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No File found to update logo.'
      );
    }

    const { type } = this.File;

    from(this.File.arrayBuffer()).subscribe({
      next: (FileArrayBuffer) => {
        const FileString = `data:${type};base64,${this.UtilityService.convertArrayBufferToBase64EncodedString(FileArrayBuffer)}`;

        if (FileString) {
          this.activeModal.close(FileString);
        }
      }
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }

  fileUpload({ data: File }: { data: File }) {
    const { name: filename, size: filesize, type: filetype } = File;

    const supportedFileTypes: File['type'][] = [
      'image/png',
      'image/jpeg',
      'image/svg'
    ];

    if (this.Files.length >= 1) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Can only upload One logo'
      );
    }

    if (!supportedFileTypes.includes(filetype)) {
      throw this.ToastService.addErrorToast(
        'Error',
        'File type not supported.'
      );
    }

    const image = new Image();
    const objectURL = URL.createObjectURL(File);
    image.onload = () => {
      const { width, height } = image;

      if (width > 300 || height > 300) {
        URL.revokeObjectURL(objectURL);
        throw this.ToastService.addErrorToast(
          'Error',
          'Max image size is 300 x 300 pixels.'
        );
      }

      this.Files.push({ filename, filesize, filetype });
      this.File = File;
      URL.revokeObjectURL(objectURL);
      this.cdr.markForCheck();
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectURL);
      throw this.ToastService.addErrorToast(
        'Error',
        'Failed to load the image.'
      );
    };

    image.src = objectURL;
  }

  removeFile({ index }: { index: number }) {
    this.Files.splice(index, 1);
    this.cdr.markForCheck();
  }
}
